// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__bgJvQ","itemTitle":"ClientEmergencyInfo_itemTitle__1P7GL","itemText":"ClientEmergencyInfo_itemText__1EYiZ"};